import React from 'react'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid'
import Img from 'gatsby-image'
import YouTube from 'react-youtube'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';


export default class MissionStatement extends React.Component{
    render(){
	var imgs = this.props.imgs;
	return(
	    <div className="section">
		<Grid>
		    <Row>
			<Col xs={10} xsOffset={1} md={6} mdOffset={0} xl={5} xlOffset={1}>
			    <Card className="card white">
				<CardContent>
				    <h2 className="title" style={{marginTop: 0}}>
					Our Mission
				    </h2>
				    <p>
					Share Meals is dedicated to ensuring all college students are food secure. We want to empower them to strengthen their own communities through sharing food and we accomplish this through technology, activism, and advocacy.
				    </p>
				</CardContent>
			    </Card>
			</Col>
			<Col xs={10} xsOffset={1} mdOffset={0} md={6} xl={5}>
			    <br className="hidden-md hidden-lg hidden-xl" />
			    <div className="youtubeWrapper">
				<iframe src="https://www.youtube.com/embed/eR9mjsff1To?modestbranding=1;controls=0;showinfo=0;" width="600" height="300" frameBorder="0" allowFullScreen="allowfullscreen"></iframe>
			    </div>
			    <p style={{textAlign: 'center'}}>
				Understanding the Need
			    </p>

			    <Img sizes={imgs.sharing_food.childImageSharp.sizes}
				 className="rounded hidden" />
			</Col>
		    </Row>
		</Grid>
	    </div>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/splash/mission-statement/index.jsx